
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"50","cy":"50","r":"50","fill":"#F5F5F5"}}),_c('path',{attrs:{"d":"M32.547 44.359c0 9.73 7.962 17.692 17.692 17.692s17.692-7.962 17.692-17.692S59.97 26.667 50.24 26.667c-9.73 0-17.692 7.961-17.692 17.692zm31.221 0c0 7.44-6.088 13.529-13.529 13.529-7.44 0-13.529-6.088-13.529-13.53 0-7.44 6.088-13.528 13.53-13.528 7.44 0 13.528 6.088 13.528 13.529zM29.633 80.991c5.516-5.516 12.8-8.534 20.606-8.534 7.805 0 15.09 3.018 20.606 8.534l2.966-2.966c-6.297-6.244-14.674-9.73-23.572-9.73s-17.276 3.486-23.572 9.73l2.966 2.966z","fill":"#CAD1D4"}})])
          )
        }
      }
    